import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalizationCacheService {
  private cacheBusterKey: string;

  constructor() {
    this.updateCacheBuster();
  }

  getCacheBuster(): string {
    return this.cacheBusterKey;
  }

  updateCacheBuster(): void {
    const today = new Date();
    // Use date to generate a cache key (YYYY-MM-DD)
    this.cacheBusterKey = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
  }
}
